import colors from 'basic-ui-lib/constants/colors';
import { IContentItem } from 'modules/channel/interfaces/api';
import { useMemo } from 'react';
import styled from 'styled-components';
import { renderMedia } from '../MainZone';

interface MainZoneTicketProps {
  value?: IContentItem[];
  activeZone?: string;
  onSelectZone?: (zone: string) => void;
  border?: number;
  gap?: number;
}

const MainZoneTicket = ({ value, activeZone, onSelectZone, border, gap }: MainZoneTicketProps) => {
  const contentByZone = useMemo(() => {
    return (
      value?.reduce<Record<string, IContentItem>>((acc, item) => {
        acc[item.zone] = item;
        return acc;
      }, {}) ?? {}
    );
  }, [value]);

  return (
    <MainZoneTicketWrapper $border={border} $gap={gap}>
      <MainZone $border={border} $active={activeZone === 'MAIN'} onClick={() => onSelectZone?.('MAIN')}>
        {renderMedia(contentByZone['MAIN'], border)}
      </MainZone>
      <Ticket $border={border} $active={activeZone === 'BOTTOM'} onClick={() => onSelectZone?.('BOTTOM')}>
        {renderMedia(contentByZone['BOTTOM'], border)}
      </Ticket>
    </MainZoneTicketWrapper>
  );
};

export default MainZoneTicket;

const MainZoneTicketWrapper = styled.div<{ $border?: number; $gap?: number }>`
  width: 100%;
  height: 100%;
  min-width: 48px;
  background-color: ${colors.neutral.text[3]};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 4px;
  border-radius: ${({ $border }) => ($border ? `${$border}px` : '1px')};
  gap: ${({ $gap }) => ($gap ? `${$gap}px` : '1px')};
`;

const MainZone = styled.div<{ $border?: number; $active?: boolean }>`
  width: 85%;
  height: 90%;
  background-color: ${colors.neutral.text[2]};
  border-radius: ${({ $border }) => ($border ? `${$border}px` : '1px')};
  border: ${({ $active }) => ($active ? `2px solid ${colors.primary[3]}` : '2px solid transparent')};
  position: relative;
`;

const Ticket = styled.div<{ $border?: number; $active?: boolean }>`
  width: 100%;
  height: 10%;
  background-color: ${colors.neutral.text[2]};
  border-radius: ${({ $border }) => ($border ? `${$border}px` : '1px')};
  border: ${({ $active }) => ($active ? `2px solid ${colors.primary[3]}` : '2px solid transparent')};
  position: relative;
`;
